export default "__VITE_ASSET__KkSKS7Nj__"